<template>
<div>


  <v-snackbar
    v-model="sb.snackbar"
    :color="sb.color"
    center top

    :timeout="2000"

  >
    {{ sb.text  }}
    <v-btn
      dark
      flat
      @click="sb.snackbar = false"
    >
      ОК
    </v-btn>
  </v-snackbar>









  <v-layout d-flex>
  <v-card>
    <v-toolbar height="42" flat>
      <v-toolbar-title>
     Ключ  антигейт <span v-if="account.balance"> | баланс: $ {{account.balance}} </span>
      </v-toolbar-title>
   <v-spacer></v-spacer>



    </v-toolbar>
  <v-card-text>



<div v-if="!account.keyy  ">
<v-text-field v-model="account.newKey"  clearable label="Вставьте сюда ваш ключ"></v-text-field>
<v-btn :loading="addingAnti" @click="addAnti()" color="primary" class="white--text"> Добавить ключ</v-btn>
</div>






    <v-toolbar  v-if="account.keyy  "  color="#EDEEF0" flat>




      <v-toolbar-title  >   {{account.keyy}}     </v-toolbar-title>

      <v-spacer></v-spacer>

<v-icon @click="copyAnti()" >mdi-content-copy</v-icon>
<v-icon @click="deleteAnti()"  >mdi-delete</v-icon>
    </v-toolbar>





  </v-card-text>


  </v-card>

  </v-layout>


</div>
</template>




<script>
import axios from 'axios'
export default {
components:{},
 data: function(){
  return {
addingAnti: false,

    sb:{
    snackbar: false,
    color: 'success',
    text: ''
       },
 account: {
   keyy: null,
   balance: null,
   newKey: null,
 },


  }
},


created(){
 this.updateAccounts()
},



methods:{
  updateAccounts: function(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/antigate/accounts_get.php', {
      contentType: 'JSONP',
       method: 'get',
       }).then(response => {
      if(response.data == null){
        this.account.keyy = null
        this.account.balance = null

 } else {
   this.getBalance()
   this.account.keyy = response.data.keyy
   this.account.balance = response.data.balance
 }
       })

  },
 getBalance(){
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/antigate/get_balance.php', {
     contentType: 'JSONP',
      method: 'get',
      }).then(response => {
          this.account.balance  = response.data.balance
      })
 },


  addAnti: function(){
   this.addingAnti = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/antigate/add.php', {
       method: 'POST',
       data: {
         keyy: this.account.newKey
       }
       }).then(response => {
         this.addingAnti = false
         if(response.data.status ==  1 ){
           this.updateAccounts()
           this.sb.color = 'success'
           this.sb.text = 'Ключ успешно добавлен'
           this.sb.snackbar = true
         } else {
           this.sb.color = 'error'
           this.sb.text = 'Извини бро, но ключ не верный ((('
           this.sb.snackbar = true
         }

       })

  },
  deleteAnti: function(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/antigate/delete.php', {
      contentType: 'JSONP',
       method: 'get',
       }).then(response => {
          this.updateAccounts()
       })

  },
  copyAnti: function(){
    if(this.account){
   navigator.clipboard.writeText(this.account.keyy)
   .then ( ()=>{
     this.sb.color = 'success'
     this.sb.text = 'Ключ успешно копирован в буфер обмена'
     this.sb.snackbar = true
   }
    )
} else {
this.sb.color = 'error'
this.sb.text = 'Ошибка копирования'
this.sb.snackbar = true
}


  },


}
}
</script>

<style>

</style>
